import React from "react";
import {Button, Card, Col, Input, message, PageHeader, Row, Tooltip} from "antd";
import 'codemirror/addon/lint/lint';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/theme/neat.css';
import 'codemirror/mode/groovy/groovy.js';
import {API} from "../api";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {handleFhirValidation, handleError, logGAEvent} from "../utils/util";
import ValidationMessages from "./validationMessages";

const {TextArea} = Input;

message.config({
    duration: 3,
    maxCount: 3,
    rtl: false
});

class ValidateSingleResource extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fhirErrors: {},
            fhirErrorsClass: 'fhir-validator-results',
            loading: false,
            fhirPreview: {id: "123", resourceType: "Patient"}
        }
    }

    /**
     * Returns whether not the FHIR validator response contains any warning.
     */
    getFhirValidationClass = (responseData) => {
        for (var i = 0; i < responseData['issue'].length; i++) {
            if (responseData['issue'][i]['severity'] === 'fatal') return 'fhir-validator-results-error';
            if (responseData['issue'][i]['severity'] === 'warning') return 'fhir-validator-results-warning';
        }
        return 'fhir-validator-results-success'
    }

    handleValidate = () => {
        logGAEvent('Validate (FHIR Validator)');
        if (this.state.fhirPreview != null && this.state.fhirPreview.resourceType != null) {
            this.setState({
                loading: true,
                fhirErrors: {}
            }, () => {
                API.post(`/validate/fhir?resourcetype=${this.state.fhirPreview.resourceType}`, this.state.fhirPreview).then(res => {
                    const validationResults = handleFhirValidation(res.data, this.state.fhirPreview);
                    this.setState({
                        fhirErrors: validationResults,
                        loading: false
                    }, () => {
                        const errorClass = this.getFhirValidationClass(validationResults);
                        this.setState({
                            fhirErrorsClass: errorClass
                        });
                        message.success("Success")
                    })
                }).catch(err => {
                    handleError(err)
                    this.setState({loading: false})
                })
            })
        } else {
            message.error("Missing resourceType key in FHIR JSON (Case sensitive).")
        }
    }

    onChangeSampleData = (e) => {
        try {
            let sampleData = JSON.parse(e.target.value);
            this.setState({
                parseError: false,
                fhirPreview: sampleData
            })
        } catch (error) {
            this.setState({parseError: true})
        }
    }

    componentDidMount = () => {
        document.title = 'FHIR Validator';
    }

    render() {
        return <>
            <PageHeader
                className="site-page-header"
                onBack={() => window.history.back()}
                title="Validate FHIR Resource"
            />
            <Row>
                <Col span={10}>
            <p>
                To validate a single resource, copy/paste the FHIR resource into the FHIR JSON card on the left.
                The validator will validate the resource using the profile specified in the <code>meta.profile</code>
                key, using the resource type in the <code>resourceType</code> key.
            </p>
                </Col>
            </Row>
            <Row gutter={[8, 8]}>
                <Col style={{marginBottom: 5}}>
                    <Button
                        disabled={this.state.parseError}
                        loading={this.state.loading}
                        onClick={() => this.handleValidate()}
                        style={{marginRight: "2px"}}
                        type="primary">
                        Validate
                    </Button>
                </Col>
            </Row>
            <Row justify="start" align="top" gutter={[20, 16]}>
                <Col span={12}>
                    <Card title={
                        <>
                            FHIR JSON
                            <Tooltip placement="right" title="The FHIR resource must be formatted as JSON">
                                &nbsp; <QuestionCircleOutlined />
                            </Tooltip>
                        </>
                    }>
                        <TextArea
                            allowClear={true}
                            className={this.state.parseError ? "parse-error-border" : ""}
                            rows={25}
                            bordered={false}
                            showCount
                            placeholder={JSON.stringify(this.state.wideView ? {} : this.state.fhirPreview, null, 2)}
                            maxLength={50000}
                            onChange={this.onChangeSampleData}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="Errors">
                    <ValidationMessages fhirErrors={this.state.fhirErrors}
                        sampleData={this.state.fhirPreview}
                    />
                    </Card>
                </Col>
            </Row>
        </>
    }
}

export default ValidateSingleResource